// extracted by mini-css-extract-plugin
export default {"grid":"GridBoard_grid__q9YfU","loading":"GridBoard_loading__PF0Nh","gridRow":"GridBoard_gridRow__ywu73","cell":"GridBoard_cell__th6-Y"};